import { API } from './resources'

export default {
  send: (likeLook, easyFind, recommendFriend, feedback, stories) => {
    return API.post('/surveyresults', { likeLook, easyFind, recommendFriend, feedback, stories })
  },
  getStats: (id, startDate, endDate) => {
    return API.get('/surveyresults/stats', { params: { id: id, startDate: startDate, endDate: endDate } })
  },
  getFeedback: (id, limit, page, startDate, endDate) => {
    return API.get('/surveyresults/feedback', { params: { id: id, limit: limit, page: page, startDate: startDate, endDate: endDate } })
  }
}
